import "./App.css";
import { Navigate, Route, Routes, Outlet } from "react-router-dom";
import Navbar from "./components/Global/Navbar";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import Sidebar from "./components/Global/Sidebar";
import Alert from "./components/Global/Toast";

import {
  PasswordUpdated,
  ResetPassword,
  Login,
  Approval,
  CompanyProfile,
  CreateTask,
  CreditMemo,
  Gantt,
  Integration,
  InviteLink,
  Onboarding,
  PlansBilling,
  PreviewCreditMemo,
  PreviewInvoice,
  PreviewRetainer,
  Procurement,
  ProjectPurchaseOrders,
  ProjectTasksList,
  QuickbooksCallback,
  Retainer,
  Signup,
  Timesheet,
  VerifyEmail,
  TimesheetApproval,
  Projects,
  CreateProject,
  ListSpecifications,
  CreateProduct,
  CreateService,
  CreateClient,
  CreateMember,
  Members,
  Clients,
  Vendors,
  SalesTax,
  SalesCategory,
  AccountSettings,
  ProjectSpecificationList,
  ProjectProposalList,
  CreateProjectProposal,
  ProposalSpecificationList,
  ProjectLocationList,
  ProjectFiles,
  CreditRetainers,
  ProjectInvoiceList,
  SettingSidebar,
  ForgotPassword,
} from "./pageListAsync";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { ProtectedRoute } from "./ProtectedRoute";
import AuthRoute from "./AuthRoute";
import { useEffect } from "react";
import useUserStore from "./utils/Stores/userStore";
import { GOOGLE_CLIENT_ID, mobileViewLinks } from "./utils/constants";
import { BsExclamationTriangle } from "react-icons/bs";
import socket from "./utils/Socket";
import useWindowSize from "./utils/hooks/useWindowSize";
import CreateVendor from "./pages/Vendor/CreateVendor";
import Tearsheet from "./pages/Tearsheet.tsx";

const ProjectPage = () => {
  return (
    <>
      <div className="flex">
        <Sidebar />
        <Outlet />

        {/* <Routes>
          <Route
            path="/specifications"
            element={
              <>
                <ProjectSpecificationList />
              </>
            }
          />
          <Route
            path="/proposals"
            element={
              <>
                <ProjectProposalList />
              </>
            }
          />

          <Route
            path="/createProposal"
            element={
              <>
                <CreateProjectProposal />
              </>
            }
          />
          <Route
            path="/createProposal/:fromID"
            element={
              <>
                <CreateProjectProposal />
              </>
            }
          />

          <Route
            path="/proposals/specifications"
            element={
              <>
                <ProposalSpecificationList />
              </>
            }
          />
          <Route
            path="/locations"
            element={
              <>
                <ProjectLocationList />
              </>
            }
          />
          <Route
            path="/files"
            element={
              <>
                <ProjectFiles />
              </>
            }
          />
          <Route
            path="/credits-retainers"
            element={
              <>
                <CreditRetainers />
              </>
            }
          />
          <Route
            path="/retainer/:fromID"
            element={
              <>
                <Retainer />
              </>
            }
          />
          <Route
            path="/previewretainer/:fromID"
            element={
              <>
                <PreviewRetainer />
              </>
            }
          />

          <Route
            path="/credit-memo/:fromID"
            element={
              <>
                <CreditMemo />
              </>
            }
          />
          <Route
            path="/previewcredit-memo/:fromID"
            element={
              <>
                <PreviewCreditMemo />
              </>
            }
          />

          <Route
            path="/purchaseorders"
            element={
              <>
                <ProjectPurchaseOrders />
              </>
            }
          />
          <Route
            path="/purchaseorders/specifications"
            element={
              <>
                <ProposalSpecificationList />
              </>
            }
          />

          <Route
            path="/createpurchaseorder"
            element={
              <>
                <CreateProjectProposal />
              </>
            }
          />

          <Route
            path="/createpurchaseorder/:fromID"
            element={
              <>
                <CreateProjectProposal />
              </>
            }
          />

          <Route
            path="/previewpurchaseorder/:fromID"
            element={
              <>
                <PreviewInvoice />
              </>
            }
          />

          <Route
            path="/previewproposal/:fromID"
            element={
              <>
                <PreviewInvoice />
              </>
            }
          />

          <Route path="/invoices" element={<ProjectInvoiceList />} />
          <Route
            path="/createinvoice"
            element={
              <>
                <CreateProjectProposal />
              </>
            }
          />

          <Route
            path="/createinvoice/:fromID"
            element={
              <>
                <CreateProjectProposal />
              </>
            }
          />

          <Route
            path="/invoices/specifications"
            element={
              <>
                <ProposalSpecificationList />
              </>
            }
          />
          <Route
            path="/previewinvoice/:fromID"
            element={
              <>
                <PreviewInvoice />
              </>
            }
          />
          <Route path="/createproject" element={<CreateProject />} />
          <Route path="/tasks" element={<ProjectTasksList />} />
          <Route path="/gantt" element={<Gantt />} />
          <Route path="/tracking" element={<Procurement />} />
          <Route path="/tasks/createtask" element={<CreateTask />} />
          <Route
            path="/tasks/createtask/:fromID"
            element={
              <>
                <CreateTask />
              </>
            }
          />
        </Routes> */}
      </div>
    </>
  );
};

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});
function App() {
  const isLogged = useUserStore((state: any) => state.isLogged);
  const fetchUser = useUserStore((state: any) => state.fetchUser);
  const user = useUserStore((state: any) => state.user);
  const setUser = useUserStore((state: any) => state.setUser);
  const { isMobile } = useWindowSize();

  useEffect(() => {
    if (isLogged && user?.selectedWorkSpace) {
      fetchUser();
    }
  }, [isLogged]);

  useEffect(() => {
    // Listen for 'import-progress' event

    socket.on("member-updated", (updatedMember) => {
      setUser({ ...user, ...updatedMember });
    });

    // Cleanup event listener when component unmounts
    return () => {
      socket.off("member-updated");
    };
  }, []);

  const routes = [
    {
      path: "/login",
      element: (
        <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
          <Login />
        </GoogleOAuthProvider>
      ),
      isProtected: false,
    },
    {
      path: "/createaccount",
      element: (
        <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
          <Signup />
        </GoogleOAuthProvider>
      ),
      isProtected: false,
    },
    {
      path: "/forgotpassword",
      element: <ForgotPassword />,
      isProtected: false,
    },

    {
      path: "/verify-email",
      element: <VerifyEmail />,
      isProtected: false,
    },

    {
      path: "/reset-password",
      element: <ResetPassword />,
      isProtected: false,
    },
    {
      path: "/passwordupdated",
      element: <PasswordUpdated />,
      isProtected: false,
    },
    {
      path: "/",
      element: isMobile ? (
        <Navigate to="/clients" />
      ) : (
        <Navigate to="/specifications" />
      ),
      isProtected: true,
    },
    {
      path: "/projects",
      element: <Projects />,
      isProtected: true,
    },
    {
      path: "/createproject",
      element: <CreateProject />,
      isProtected: true,
    },
    {
      path: "/specifications",
      element: <ListSpecifications />,
      isProtected: true,
    },

    {
      path: "/createproduct",
      element: <CreateProduct />,
      isProtected: true,
    },

    {
      path: "/createservice",
      element: <CreateService />,
      isProtected: true,
    },
    {
      path: "/createproduct/:id",
      element: <CreateProduct />,
      isProtected: true,
    },
    {
      path: "/createservice/:id",
      element: <CreateService />,
      isProtected: true,
    },
    {
      path: "/createvendor",
      element: <CreateVendor />,
      isProtected: true,
    },
    {
      path: "/createvendor/:id",
      element: <CreateVendor />,
      isProtected: true,
    },
    {
      path: "/createclient",
      element: <CreateClient />,
      isProtected: true,
    },
    {
      path: "/createmember",
      element: <CreateMember />,
      isProtected: true,
    },
    {
      path: "/createmember/:id",
      element: <CreateMember />,
      isProtected: true,
    },
    {
      path: "/createclient/:id",
      element: <CreateClient />,
      isProtected: true,
    },
    {
      path: "/team",
      element: <Members />,
      isProtected: true,
    },
    {
      path: "/clients",
      element: <Clients />,
      isProtected: true,
    },
    {
      path: "/vendors",
      element: <Vendors />,
      isProtected: true,
    },
    {
      path: "/companyprofile",
      element: <CompanyProfile />,
      isProtected: true,
    },
    {
      path: "/sales-tax",
      element: <SalesTax />,
      isProtected: true,
    },
    {
      path: "/sales-category",
      element: <SalesCategory />,
      isProtected: true,
    },
    {
      path: "/timesheet",
      element: <Timesheet />,
      isProtected: true,
    },
    {
      path: "/approval",
      element: <Approval />,
      isProtected: true,
    },
    {
      path: "/approval/:userId",
      element: <TimesheetApproval />,
      isProtected: true,
    },

    {
      path: "/onboarding",
      element: <Onboarding />,
      isProtected: true,
    },

    {
      path: "/invite/:token",
      element: <InviteLink />,
      isProtected: false,
    },

    {
      path: "/quickbooks/callback",
      element: <QuickbooksCallback />,
      isProtected: true,
    },
    {
      path: "tearsheet",
      element: <Tearsheet />,
      isProtected: true,
    },

    {
      path: "/account/",
      element: <SettingSidebar />,
      isProtected: true,
      children: [
        { path: "settings", element: <AccountSettings /> },
        // { path: "sales-tax", element: <SalesTax /> },
        // { path: "sales-category", element: <SalesCategory /> },
        { path: "plans-billings", element: <PlansBilling /> },
        { path: "integrations", element: <Integration /> },
      ],
    },
    {
      path: "/project/:id/*",
      element: <ProjectPage />,
      isProtected: true,
      children: [
        {
          path: "specifications",
          element: (
            <>
              <ProjectSpecificationList />
            </>
          ),
        },
        {
          path: "proposals",
          element: (
            <>
              <ProjectProposalList />
            </>
          ),
        },
        {
          path: "createProposal",
          element: (
            <>
              <CreateProjectProposal />
            </>
          ),
        },
        {
          path: "createProposal/:fromID",
          element: (
            <>
              <CreateProjectProposal />
            </>
          ),
        },
        {
          path: "proposals/specifications",
          element: (
            <>
              <ProposalSpecificationList />
            </>
          ),
        },
        {
          path: "locations",
          element: (
            <>
              <ProjectLocationList />
            </>
          ),
        },
        {
          path: "files",
          element: (
            <>
              <ProjectFiles />
            </>
          ),
        },
        {
          path: "credits-retainers",
          element: (
            <>
              <CreditRetainers />
            </>
          ),
        },
        {
          path: "purchaseorders",
          element: (
            <>
              <ProjectPurchaseOrders />
            </>
          ),
        },
        {
          path: "purchaseorders/specifications",
          element: (
            <>
              <ProposalSpecificationList />
            </>
          ),
        },
        {
          path: "createpurchaseorder",
          element: (
            <>
              <CreateProjectProposal />
            </>
          ),
        },
        {
          path: "createpurchaseorder/:fromID",
          element: (
            <>
              <CreateProjectProposal />
            </>
          ),
        },
        {
          path: "previewpurchaseorder/:fromID",
          element: (
            <>
              <PreviewInvoice />
            </>
          ),
        },
        {
          path: "previewproposal/:fromID",
          element: (
            <>
              <PreviewInvoice />
            </>
          ),
        },
        {
          path: "invoices",
          element: (
            <>
              <ProjectInvoiceList />
            </>
          ),
        },
        {
          path: "createinvoice",
          element: (
            <>
              <CreateProjectProposal />
            </>
          ),
        },
        {
          path: "createinvoice/:fromID",
          element: (
            <>
              <CreateProjectProposal />
            </>
          ),
        },
        {
          path: "invoices/specifications",
          element: (
            <>
              <ProposalSpecificationList />
            </>
          ),
        },
        {
          path: "previewinvoice/:fromID",
          element: (
            <>
              <PreviewInvoice />
            </>
          ),
        },
        {
          path: "createproject",
          element: (
            <>
              <CreateProject />
            </>
          ),
        },
        {
          path: "tasks",
          element: (
            <>
              <ProjectTasksList />
            </>
          ),
        },
        {
          path: "gantt",
          element: (
            <>
              <Gantt />
            </>
          ),
        },
        {
          path: "tracking",
          element: (
            <>
              <Procurement />
            </>
          ),
        },
        {
          path: "tasks/createtask",
          element: (
            <>
              <CreateTask />
            </>
          ),
        },
        {
          path: "tasks/createtask/:fromID",
          element: (
            <>
              <CreateTask />
            </>
          ),
        },
        {
          path: "credit-memo/:fromID",
          element: (
            <>
              <CreditMemo />
            </>
          ),
        },
        {
          path: "previewcredit-memo/:fromID",
          element: (
            <>
              <PreviewCreditMemo />
            </>
          ),
        },
        {
          path: "retainer/:fromID",
          element: (
            <>
              <Retainer />
            </>
          ),
        },
        {
          path: "previewretainer/:fromID",
          element: (
            <>
              <PreviewRetainer />
            </>
          ),
        },
      ],
    },
  ];

  const renderRoutes = (routes) =>
    routes.map(({ path, element, isProtected, children }) => (
      <Route
        key={path}
        path={path}
        element={
          isProtected ? (
            <>
              <ProtectedRoute>
                <Navbar /> {element}
              </ProtectedRoute>
            </>
          ) : (
            <>
              <AuthRoute>{element}</AuthRoute>
            </>
          )
        }
      >
        {children?.map((child) => (
          <Route key={child.path} path={child.path} element={child.element} />
        ))}
      </Route>
    ));

  return (
    <div className="text-black-primary font-inter">
      <DesktopMsg />
      <QueryClientProvider client={queryClient}>
        <Routes>
          {renderRoutes(routes)}
          {/* <Route path="/project/:id/*" element={<ProjectPage />} /> */}
        </Routes>

        {/* to display toasts on each screen */}
        <Alert />
      </QueryClientProvider>

      {/* <RouterProvider router={router} /> */}
    </div>
  );
}

const DesktopMsg = () => {
  const { isMobile, isMobileLink } = useWindowSize();

  return (
    <div
      className="desktop-message"
      style={{
        display: (isMobile && isMobileLink) || !isMobile ? "none" : "block",
      }}
    >
      <div className="h-full flex flex-col justify-center items-center w-full mx-auto">
        <div className="flex justify-center mb-2">
          <div className="bg-[#FFFAEB] p-2 rounded-full max-w-fit flex justify-center items-center text-center">
            <div className="w-8 h-8 bg-[#FEF0C7] rounded-full flex justify-center items-center text-customGreen-primary">
              <BsExclamationTriangle className="text-[#B54708]" />
            </div>
          </div>
        </div>
        <h1 className="text-base font-semibold text-black-primary">
          Desktop Only Access
        </h1>
        <p className="text-gray-600 text-sm font-normal">
          This application is best experienced on a desktop. Please use a larger
          screen to access it.
        </p>
      </div>
    </div>
  );
};

export default App;
